import SectionWrapper from '@/components/_rebrand/craft/SectionWrapper';
import { StyleOverride } from '@/types/craft-style-overrides';
import cn from 'classnames';
import { FC } from 'react';
import { DrawerGrid } from './DrawerGrid';
import { DrawerHeader } from './DrawerHeader';
import { FaqDrawerProps } from './FaqDrawer';

export type FaqDrawerListProps = {
  title: string;
  description?: React.ReactNode;
  hasDarkBackground?: boolean;
  drawers: FaqDrawerProps[];
  styleOverrides?: StyleOverride;
}

const FaqDrawerList: FC<FaqDrawerListProps> = ({
  title,
  description,
  hasDarkBackground,
  drawers = [],
  styleOverrides,
}) => (
  <SectionWrapper
    styleOverrides={styleOverrides}
    className={cn({
      'my-8 md:my-22': !hasDarkBackground,
    })}
  >
    <div
      className={cn('px-container-mobile md:px-container-desktop flex flex-col gap-3 md:gap-8', {
        'py-4 md:py-12 bg-violet-900': hasDarkBackground,
        'my-8 md:my-22': !styleOverrides && !hasDarkBackground,
        'py-1': styleOverrides,
      })}
    >
      <div
        className={cn('mx-auto max-w-grid flex flex-col gap-2 md:gap-8 rounded-[16px]', {
          'bg-violet-800 pb-[48px] md:pb-[120px]': hasDarkBackground,
        })}
      >
        <DrawerHeader title={title} description={description} hasDarkBackground={hasDarkBackground} />
        <DrawerGrid drawers={drawers} hasDarkBackground={hasDarkBackground} />
      </div>
    </div>
  </SectionWrapper>
);

export default FaqDrawerList;
